import { SOURCE_REGISTRY_ERRORS } from '../../constants/ErrorConstants';
import { InputElementModel } from '../services/InputElementModel';
import { ISourceRegistryValidationModel } from './ISourceRegistryValidationModel';

const sourceRegistryName: InputElementModel = {
  name: 'sourceRegistryName',
  value: '',
  error: SOURCE_REGISTRY_ERRORS.invalidSourceRegistryName,
  expression: /^[a-zA-Z](-*[a-zA-Z0-9])*$/,
  isValid: true,
  isTouched: false
};

const identifiers: InputElementModel = {
  name: 'identifiers',
  value: '',
  error: SOURCE_REGISTRY_ERRORS.invalidIdentifiers,
  expression: /^[a-zA-Z](-*[a-zA-Z0-9_$])*$/,
  isValid: true,
  isTouched: false
};

const eventName: InputElementModel = {
  name: 'eventName',
  value: '',
  error: SOURCE_REGISTRY_ERRORS.invalidEventName,
  expression: /^[a-zA-Z](-*[a-zA-Z0-9])*$/,
  isValid: true,
  isTouched: false
};

const identifiersArray: InputElementModel = {
  name: 'identifiersArray',
  value: ''
};

const requestSpecJson: InputElementModel = {
  name: 'requestSpecJson',
  value: '',
  error: SOURCE_REGISTRY_ERRORS.jsonTransformation,
  isValid: true,
  isTouched: false
};

const responseSpecJson: InputElementModel = {
  name: 'responseSpecJson',
  value: '',
  error: SOURCE_REGISTRY_ERRORS.jsonTransformation,
  isValid: true,
  isTouched: false
};

const replyToTopic: InputElementModel = {
  name: 'replyToTopic',
  value: '',
  error: SOURCE_REGISTRY_ERRORS.invalidReplyTopicName,
  expression: /^[a-zA-Z](-*[a-zA-Z0-9])*$/,
  isValid: true,
  isTouched: false
};

const replyTimeOut: InputElementModel = {
  name: 'replyTimeOut',
  value: '',
  error: SOURCE_REGISTRY_ERRORS.invalidReplyTimeOut,
  expression: /^(?:[1-9]\d?|1\d{2}|200)$/,
  isValid: true,
  isTouched: false
};

export class SourceRegistryFormData implements ISourceRegistryValidationModel {
  sourceRegistryName: InputElementModel;

  identifiers: InputElementModel;

  eventName: InputElementModel;

  requestSpecJson: InputElementModel;

  responseSpecJson: InputElementModel;

  identifiersArray: InputElementModel;

  replyTimeOut: InputElementModel;

  replyToTopic: InputElementModel;

  constructor() {
    this.sourceRegistryName = sourceRegistryName;
    this.identifiers = identifiers;
    this.eventName = eventName;
    this.identifiersArray = identifiersArray;
    this.requestSpecJson = requestSpecJson;
    this.responseSpecJson = responseSpecJson;
    this.replyTimeOut = replyTimeOut;
    this.replyToTopic = replyToTopic;
  }
}
